import script from "./FeedbackPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackPanel.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackPanel.vue?vue&type=style&index=0&id=21e5f64b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e5f64b"]])

export default __exports__